export default {"src":"/_next/static/media/compliance.dd98a84b.svg","height":512,"width":384,"blurWidth":0,"blurHeight":0};